import
  React, {
  useContext
} from 'react';

import {
  ColorSvg,
  HContainerVH,
  Text
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../../constants';

import {
  AppContext
} from 'context';

export const NoOffers = () => {

  const { config } = useContext(AppContext);

    return (

      <HContainerVH
        boxShadow={`0px 5px 15px 0px ${CustomColors.TransparentBlack1}`}
        borderRadius={'4px'}>

        <ColorSvg
          src={Icons.WarningCircle}
          color={CustomColors.Red1}
          maxWidth={'24px'}
          maxHeight={'24px'}
          minWidth={'24px'}
          minHeight={'24px'}
          padding={'0 12px 0 16px'} />

        <Text
          fontSize={'14px'}
          padding={(config?.j4uErrorMessage && '0 16px 0 0') || '16px 16px 16px 0'}
          dangerouslySetInnerHTML={{
            __html: config?.j4uErrorMessage || 'Sorry, there are no offers available at the moment in your area.'
          }}/>
      </HContainerVH>
    );
};